import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { requests } from "../../utils/api/api.service";
import { EMAIL_TEMPLATES_URL } from "../../utils/api/endpoints";
import { IEmailTemplate } from "../../shared/interfaces/email-template/IEmailTemplate";

export const AdminEmailTemplateService = {
  get: (pagination: IPagination): Promise<IBaseModel<IEmailTemplate[]>> =>
    requests.get(EMAIL_TEMPLATES_URL, pagination),
  getSingle: (id: number): Promise<IEmailTemplate> =>
    requests.get(`${EMAIL_TEMPLATES_URL}/${id}`),
  create: (params: IEmailTemplate) =>
    requests.post(EMAIL_TEMPLATES_URL, params),
  update: (params: IEmailTemplate, id: number) =>
    requests.put(`${EMAIL_TEMPLATES_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${EMAIL_TEMPLATES_URL}/${id}`),
};
